import React from "react";
import { SlidePages } from "../../components/slidePages";
import img from "../../assets/images/itiP.png";
import ite1 from "../../assets/images/iti1.png";
import ite2 from "../../assets/images/iti2.png";
import ite3 from "../../assets/images/iti3.png";
import { Prestations } from "../../components/home/prestations";
import { DemandeDevis } from "../../components/home/demandeDevis";
import { Realisation } from "../../components/home/realisation";
import { EnergetiqueIcon } from "../../assets/icons/EnergetiqueIcon";
import { ValorisationIcon } from "../../assets/icons/ValorisationIcon";
import { HiverIcon } from "../../assets/icons/HiverIcon";
import { MaPrimeRénov } from "../../assets/icons/MaPrimeRénov";
import { IntroService } from "../../components/serviceDetails/introService";
import { Interventions } from "../../components/serviceDetails/intervention";
import rea1 from "../../assets/images/rea10.png";
import rea2 from "../../assets/images/rea11.png";
import rea3 from "../../assets/images/rea12.png";
import rea4 from "../../assets/images/rea13.png";
import rea5 from "../../assets/images/rea14.png";
import rea6 from "../../assets/images/rea15.png";
export const ItIPage = () => {
  const items = [
    {
      icon: <EnergetiqueIcon />,
      text: "Solution rapide et économique",
    },
    {
      icon: <ValorisationIcon />,
      text: "Travaux sans autorisation d’urbanisme",
    },
    {
      icon: <HiverIcon />,
      text: "Parfait pour logements occupés ou petits budgets",
    },
    {
      icon: <MaPrimeRénov />,
      text: "Eligible à MaPrimeRénov’ et CEE",
    },
  ];
  const realisations = [
    {
      image: rea1,
      text: "Isolation intérieure",
      link: "/ITI",
    },
    {
      image: rea2,
      text: "Isolation intérieure",
      link: "/ITI",
    },
    {
      image: rea3,
      text: "Isolation intérieure",
      link: "/ITI",
    },
    {
      image: rea4,
      text: "Isolation intérieure",
      link: "/ITI",
    },
    {
      image: rea5,
      text: "Isolation intérieure",
      link: "/ITI",
    },
    {
      image: rea6,
      text: "Isolation intérieure",
      link: "/ITI",
    },
  ];
  const prestations = [
    {
      icon: ite1,
      text: "Pose de plaques isolantes, doublage, laine de roche ou polystyrène",
    },
    {
      icon: ite2,
      text: "Traitement des ponts thermiques",
    },
    {
      icon: ite3,
      text: "Finitions soignées",
    },
  ];
  return (
    <div>
      {" "}
      <SlidePages
        title={"Isolation intérieure (ITI)"}
        description={
          "Alternative efficace à l’ITE, l’isolation intérieure permet d’améliorer le confort thermique d’un logement sans modification de la façade."
        }
      />
      <IntroService items={items} img={img} />
      <Interventions
        title={"Notre intervention"}
        description={
          "Des techniques maîtrisées pour isoler sans modifier l’aspect extérieur."
        }
        prestations={prestations}
      />
      <Realisation realisations={realisations} />
      <DemandeDevis title={"Obtenez votre devis ITI en ligne !"} />
      <Prestations
        title={"D’autres services"}
        description={
          "Des solutions durables pour un habitat plus beau, plus sain et moins énergivore."
        }
      />
    </div>
  );
};
